export const EXCHANGE_CODES = {
  'NSE': 1,
  'NFO': 2,
  'CDS': 3,
  'MCX': 4,
  'BSE': 6
};

export const SUBSCRIPTION_TYPES = {
  MARKETDATA: 'marketdata',
  SPREAD: 'spread_marketdata',
  SNAPQUOTE: 'snapquote',
};

export const WS_STATES = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3
}; 